import React from 'react';
import styles from '../assets/css/auth.module.css';
import Logo from '../assets/img/Kwenda-Logo.svg';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

const logoutSuccess = () => {
  return (
    <div className={styles.auth_main}>
      <div className={styles.auth_form}>
        <div className={styles.auth_form_header}>
          <div>
            <h2>تم تسجيل خروجك بنجاح</h2>
          </div>
          <Link to='/' style={{ marginTop: '0' }}>
            <img className={styles.auth_logo} alt="Kwenda Logo" src={Logo} />
          </Link>
        </div>
        <div className="success_message logout_success">
          <p>شكرا لإستخدامك كويندا, نسعد دائما بخدمتك</p>
          <button className={classNames('button', styles.button)} >
            تسجيل الدخول
          </button>
          <Link to="../">العودة الى الصفحة الرئيسية</Link>
        </div>

      </div>
    </div>
  );
};

export default logoutSuccess;